export const WfUtil = function () {
  this._vue = null
  this.init = function (vue) {
    this._vue = vue
  }
  this.initModel = (res) => { // 根据获取到的模型列表判断
    let vue = this._vue
    // console.log('------initModel------',res)
    // 如果是第一环节说明是驳回或者是不同意，并且是从表单中直接打开
    if (res.data.ifFirstNode && res.data.ifStartUser && res.data.activities && res.data.activities.length > 0) {
      vue.renderApprovalForm(res.data)
      vue.initProcessMonitor()
      return
    }
    let mainData = this.getMainData()
    // console.info('----mainData----',mainData)
    if (mainData != null) {
      // 判断如果不是创建人则不能发起流程
      if (mainData['CREATE_USER_'] && mainData['CREATE_USER_'] !== vue.sessionUtil.getUserUid()) {
        vue.isReadOnly = true
        vue.isWorkflow = false
        vue.updateReadOnly(true)
        if (vue.model.parent.unmask != undefined) {
          vue.model.parent.unmask()
        }
        if (vue.model.parent.openConfig) {
          console.log('*****************', vue.model.parent.openConfig)
          if (vue.model.parent.openConfig.readOnly === false) {
            vue.isReadOnly = false
            // vue.isWorkflow = true
          }
        }
        return
      }
    }
    let modelList = res.data.modelList
    if (modelList != undefined && modelList.length > 0) {
      for (var i = 0; i < modelList.length; i++) {
        // 默认第一个选中
        if (i == 0) {
          modelList[i].selected = true
        } else {
          modelList[i].selected = false
        }
        modelList[i].id = modelList[i].key
      }
      vue.isWorkflow = true
      vue.modelList = modelList
      if (modelList.length === 1) {
        // 判断如果是编辑的时候，且只有一个流程才直接计算，如果是新增，因为客户还没有录完数据，如果直接触发计算，则结果不准
        if(vue.validUtil.isNotNull(vue.id)){
          wfUtil.compute()
        }
      }
      vue.isEndEvent = false
      if (vue.readOnly || res.data.ifStartUser === false) {
        vue.isReadOnly = true
        vue.isWorkflow = false
      } else {
        vue.isReadOnly = false
      }
      if (vue.model.parent.unmask != undefined) {
        vue.model.parent.unmask()
      }
    } else {
      // 没有绑定流程，或者已经存在流程示例
      if (res.data.procInstId != undefined) {
        // vue.util.failueToast("已经存在流程实例！");
        let data = res.data
        vue.procInstId = res.data.procInstId
        vue.procDefId = res.data.procDefId
        // 判断是否发起人，并且流程没有结束
        if (data.ifStartUser && data.enable == 1) {
          vue.isWorkflow = true
          vue.isApply = true
        } else {
          console.log('----@@-----', data)
        }
        vue.updateReadOnly(true)
        vue.initProcessMonitor()
        if (vue.model.parent.openConfig) {
          console.log('*********2********', vue.model.parent.openConfig)
          if (vue.model.parent.openConfig.readOnly === false) {
            vue.isReadOnly = false
            vue.isWorkflow = false
            // vue.isWorkflow = true
          }
        }
        if (vue.model.parent.unmask != undefined) {
          vue.model.parent.unmask()
        }
      } else {
        // 没有绑定流程
        // console.info(vue.model.parent, '------------' + vue.model.parent.readOnly, vue.isWorkflow)
        // 显示提交按钮，用来提交修改lock = -5

        if (vue.readOnly) {
          vue.isReadOnly = true
        } else {
          vue.isReadOnly = false
        }

        if (mainData != null) {
          // 判断是否仅提交lock=-5
          if (mainData['PROC_STATUS_'] && mainData['PROC_STATUS_'] === -5) {
            vue.isReadOnly = true
            vue.isWorkflow = false
            vue.updateReadOnly(true)

          }
          if (vue.model.parent.unmask != undefined) {
            vue.model.parent.unmask()
          }
        }
      }
    }
  }
  this.compute = () => { // 根据启动规则计算流程
    let _this = this
    let vue = this._vue
    let modelList = vue.modelList
    let mainData = this.getMainData()
    // console.info(mainData)
    if (mainData != null) {
      modelList = modelList.filter(function (model) {
        if (model.config) {
          let config = JSON.parse(model.config)
          let startRules = config.startRules
          if (startRules) {
            // console.info(startRules)
            let flag = _this.computeStartRule(mainData, startRules)
            if (!flag) {
              // 由于新增数据时候流程规则计算总是不满足 暂时注解掉
              return null
            }
          }
        }
        return model
      })
    }
    for (var i = 0; i < modelList.length; i++) {
      // 默认第一个选中
      if (i == 0) {
        modelList[i].selected = true
      } else {
        modelList[i].selected = false
      }
      modelList[i].id = modelList[i].key
    }
    if (modelList.length == 0) {
      vue.util.warn('没用找到满足条件的流程！')
    } else {
      vue.processList = modelList
      if (modelList.length === 1) {
        let model = modelList[0]
        vue.procDefId = model.procDefId
        vue.key = model.key
        vue.isWorkflow = true
        vue.procDefName = model.name
        // 加载流程处理单
        vue.loadExecution()
      } else {
        vue.dialogSelProcVisible = true
      }
    }
    // console.info(modelList)
  }
  this.getMainData = () => {
    let vue = this._vue
    // console.info(vue.model.parent)
    // console.info(vue.model.parent.getData)
    // 判断表单是否复写获取数据的方法
    if (vue.model.parent.getData != undefined) {
      var formData = vue.model.parent.getData()
      // console.info(formData)
      if (formData) {
        let mainData = formData.mainFormDataMap
        if (typeof mainData === 'string') {
          mainData = JSON.parse(mainData)
        }
        return mainData
      }
    }
    return null
  }
  this.computeStartRule = (mainData, startRules) => { // 根据启动规则计算流程
    for (var i = 0; i < startRules.length; i++) {
      let rule = startRules[i]
      // console.info(mainData)
      let value = mainData[rule.field];
      // 判断字段是否是id,还是name,
      let isId = false;
      if(rule.field.endWith('ID_')){
        isId = true;
      }
      // console.info(rule.field+'=='+mainData['TAX_MONEY_']+'=='+value+'=='+typeof mainData)
      if (rule.ruleType === 'rule-user') {
        if (value == undefined || value == null) {
          return false
        }
        let valArr = rule.value
        let flag = false
        for (let m = 0; m < valArr.length; m++) {
          if(isId){
            if (valArr[m].id === value) {
              flag = true
              break
            }
          }else{
            if (valArr[m].userName === value) {
              flag = true
              break
            }
          }
        }
        if (!flag) {
          return false
        }
      } else if (rule.ruleType === 'rule-depart') {
        if (value == undefined || value == null) {
          return false
        }
        let valArr = rule.value
        let flag = false
        for (let m = 0; m < valArr.length; m++) {
          if(isId){
            if (valArr[m].id === value) {
              flag = true
              break
            }
          }else{
            if (valArr[m].departName === value) {
              flag = true
              break
            }
          }

        }
        if (!flag) {
          return false
        }
      } else if (rule.ruleType === 'rule-contain') {
        if (value == undefined || value == null) {
          return false
        }
        let valArr = rule.value
        if (typeof rule.value === 'string') {
          valArr = rule.value.split(',')
        }
        console.log(rule,rule.field + '--' + value + '--' + rule.value + '--' + typeof value, valArr)
        let flag = false
        for (let m = 0; m < valArr.length; m++) {
          if (typeof value === 'string' && value.indexOf(',') > -1) {
            if (value.indexOf(valArr[m]) > -1) {
              flag = true
              break
            }
          } else {
            if (typeof value === 'number') {
              if (Number(valArr[m]) === Number(value)) {
                flag = true
                break
              }
            } else {
              if (valArr[m] === value) {
                flag = true
                break
              }
            }
          }
        }
        if (!flag) {
          return false
        }
      } else if (rule.ruleType === 'rule-compare') {
        if (rule.compareType === 'between') {
          let minVal = rule.minVal
          let maxVal = rule.maxVal
          var flag = true
          var compareStr = 'flag = (' + value + '>=' + minVal + ' && ' + value + '<' + maxVal + ')'
          eval(compareStr)
          // console.info(compareStr+'-----'+flag)
          if (!flag) {
            return false
          }
        } else {
          if (value == undefined || value == null) {
            return false
          }
          var flag = true
          var compareStr = 'flag = (' + value + rule.compareType + rule.value + ')'
          // console.info(rule,compareStr+'-----',value,typeof value)
          eval(compareStr)

          // console.info(compareStr+'-----'+flag)
          if (!flag) {
            return false
          }
        }
      } else if (rule.ruleType === 'rule-equal') {
        if (value == undefined || value == null) {
          return false
        }
        if (value != rule.value) {
          return false
        }
      }
    }
    return true
  }
}
export const wfUtil = new WfUtil()



// WEBPACK FOOTER //
// ./src/common/wf/v2/process-form.js